import Layout from '../views/layout/layout'

export default {
    path: '/project',
    name: 'project',
    component: Layout,
    children: [
        {
            path: '/project/quality/qualityItem',
            name: 'qualityItem',
            component: () => import('../views/project/quality/qualityItem/index'),
            meta: {title: '质检项列表', keepAlive: true}
        },
        {
            path: '/project/quality/qualityForm',
            name: 'qualityForm',
            component: () => import('../views/project/quality/qualityForm/index'),
            meta: {title: '质检表单管理', keepAlive: true}
        },
        {
            path: '/project/quality/qualityForm/formConfig',
            name: 'formConfig',
            component: () => import('../views/project/quality/qualityForm/formConfig'),
            meta: {title: '质检表单配置'}
        },

    ]
}
